<div class="lift-margin-right c-portlet_box_specs" style="position: relative;">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini stats-container u-bg-primary {{ sectionclass }}"
	>
		<!-- style="background: #cdcdcd !important; height: 100%;" -->
		<div *ngIf="hasLiftData; else noLiftDataBlock" class="set_background_color">
			<div class="c-portlet o-block u-width-100p _u-width-100p u-border-bottom">
				<div class="o-stack__cell">
					<h5 class="title primary-color">{{ sectiontitle }}</h5>
				</div>
			</div>

			<div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content stats_content lift_details_row">
				<div
					class="content_mainCls content_mainClas_Lift_Row lift_stats_subsection lift_stats_subtitle-r11 tertiary-color"
				>
					People who see your digital ad are <br />
					<b
						><span *ngIf="liftStatsData">{{ liftStatsData.digitalLift }}</span
						>x more likely to visit your website.</b
					>
				</div>
				<div class="o-stack o-stack--center _u-px-small lift_stats">
					<!--  style="text-align: center"-->
					<div class="o-stack__cell content_mainCls text_align_center content_mainClas_Lift_Row">
						<!--  style="display: block; font-size: 1.5em; font-weight: bold" -->
						<span
							class="u-font-medium u-lh-normal u-opacity-80p stats_value lift_stats_data secondary-color"
							*ngIf="liftStatsData"
							>{{ liftStatsData.digitalLift }}x</span
						>
						<span class="list_stats_name">Digital Lift</span>
					</div>
					<!-- style="text-align: center" -->
					<div class="o-stack__cell content_mainCls text_align_center content_mainClas_Lift_Row">
						<!-- style="display: block; font-size: 1.5em; font-weight: bold" -->
						<span
							class="u-font-medium u-lh-normal u-opacity-80p stats_value lift_stats_data secondary-color"
							*ngIf="liftStatsData"
							>{{ liftStatsData.exposedRate }}%</span
						>
						<span class="list_stats_name_ExpRate">Exposed Rate</span>
					</div>
					<!-- style="text-align: center" -->
					<div class="o-stack__cell content_mainCls text_align_center content_mainClas_Lift_Row">
						<!-- style="display: block; font-size: 1.5em; font-weight: bold" -->
						<span
							class="u-font-medium u-lh-normal u-opacity-80p stats_value lift_stats_data secondary-color"
							*ngIf="liftStatsData"
							>{{ liftStatsData.baseLineRate }}%</span
						>
						<span class="list_stats_name">Baseline Rate</span>
					</div>
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div
					class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini stats-container u-bg-primary {{
						sectionclass
					}}"
				>
					<!-- style="background: #cdcdcd !important; height: 100%;" -->
					<div class="set_background_color">
						<div
							class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header"
						>
							<div class="o-stack__cell">
								<h5>{{ sectiontitle }}</h5>
							</div>
						</div>
					</div>
				</div>
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
		<ng-template #noLiftDataBlock>
			<div class="set_background_color_no_data">
				<div class="c-portlet o-block u-width-100p _u-width-100p u-border-bottom" style="margin-bottom: 35px;">
					<div class="o-stack__cell">
						<h5 class="title primary-color">{{ sectiontitle }}</h5>
					</div>
				</div>
				<div class="u-px-small no_lift_data_block stats_content">
					<div class="lift_stats_subhead">
						Campaigns in the selected date range are not eligible for lift reporting.
					</div>
					<div class="lift_stats_sub_section">
						<div class="lift_stats_subhead" style="padding-top: 5px;">
							A campaign must meet all of the following 3 requirements to receive lift reporting:
						</div>
						<div>
							<ul class="lift_stats_list">
								<li>- Campaign must have the pixel placed and firing on the website</li>
								<li>- Campaign must run for 3 consecutive months</li>
								<li>- Campaign must run at least 50,000 audience extension impressions per month</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</ng-template>
	</div>
</div>
